import { motion } from "framer-motion"
import { RiMailLine, RiMapPinLine, RiTimeLine } from "@remixicon/react"

import { ColorBand, ColorBandInner } from "@/components/landing/ColorBand"
import { MarketingPageShell } from "@/components/landing/MarketingPageShell"
import { fadeIn, fadeUp } from "@/components/landing/marketing-motion"
import { Button } from "@/components/ui/button"
import { APP_REGISTER_URL } from "@/lib/site"

export function ContactPage() {
  return (
    <MarketingPageShell
      eyebrow="Contact"
      title="Let's talk about your sales link"
      description="Sales, partnerships, press, or product questions? Reach Sqaleup Inc. directly."
      heroVariant="primary"
      bare
    >
      <ColorBand className="bg-[#f6f4ef] text-primary">
        <ColorBandInner>
          <motion.div
            {...fadeUp}
            className="rounded-[2.5rem] bg-white p-8 sm:rounded-[3rem] sm:p-12 lg:p-14"
          >
            <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:gap-14">
              <a
                href="mailto:hello@sqaleshop.com"
                className="group flex shrink-0 items-center justify-center"
              >
                <span className="flex size-20 items-center justify-center rounded-[1.75rem] bg-[#d4c4fc] text-primary transition-transform duration-300 group-hover:scale-[1.03] lg:size-24 lg:rounded-[2rem]">
                  <RiMailLine className="size-10 lg:size-11" />
                </span>
              </a>
              <div className="min-w-0 flex-1">
                <p className="font-heading text-sm font-semibold uppercase tracking-[0.18em] text-primary/60">
                  Email us
                </p>
                <a
                  href="mailto:hello@sqaleshop.com"
                  className="font-display mt-3 block text-3xl leading-[0.95] text-primary transition-colors hover:text-primary/80 sm:text-4xl lg:text-[2.75rem]"
                >
                  hello@sqaleshop.com
                </a>
                <p className="mt-4 max-w-2xl text-base font-semibold leading-relaxed text-primary/65 xl:text-lg">
                  Custom plans, compliance questions, and general inquiries. Tap
                  the address to open your mail app.
                </p>
                <div className="mt-8 flex flex-wrap gap-3">
                  <Button
                    size="xl"
                    className="rounded-full px-8 font-semibold shadow-none"
                    asChild
                  >
                    <a href="mailto:hello@sqaleshop.com?subject=Sqaleshop%20inquiry">
                      Compose email
                    </a>
                  </Button>
                  
                </div>
              </div>
            </div>
          </motion.div>

          <div className="mt-6 grid gap-5 md:grid-cols-2">
            <motion.div
              {...fadeIn}
              className="rounded-[2.5rem] bg-[#d2e4c4] p-8 sm:p-10"
            >
              <span className="flex size-12 items-center justify-center rounded-2xl bg-white/70 text-primary">
                <RiTimeLine className="size-6" />
              </span>
              <p className="font-heading mt-5 text-xl text-primary">
                Response time
              </p>
              <p className="mt-3 text-sm font-semibold leading-relaxed text-primary/70 sm:text-base">
                We typically reply within one to two business days. Premium
                merchants receive faster handling through in-app channels.
              </p>
            </motion.div>

            <motion.div
              {...fadeIn}
              transition={{ ...fadeIn.transition, delay: 0.06 }}
              className="rounded-[2.5rem] bg-[#d4c4fc] p-8 sm:p-10"
            >
              <span className="flex size-12 items-center justify-center rounded-2xl bg-white/70 text-primary">
                <RiMapPinLine className="size-6" />
              </span>
              <p className="font-heading mt-5 text-xl text-primary">
                Sqaleup Inc.
              </p>
              <p className="mt-3 text-sm font-semibold leading-relaxed text-primary/70 sm:text-base">
                Worldwide team building Sqaleshop for small businesses in
                Nigeria and beyond.
              </p>
            </motion.div>
          </div>
        </ColorBandInner>
      </ColorBand>
    </MarketingPageShell>
  )
}
